import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type ReportCollapsableSectionProps = React.PropsWithChildren<{
	title: string;
	scorePercent: number;
	isOpen: boolean;
	isPdf: boolean;
	onToggle: () => void;
}>;

export function ReportCollapsableSection({isOpen, onToggle, scorePercent, title, children, isPdf}: ReportCollapsableSectionProps) {
	return (
		<div className="chart-row">
			<div>
				<div className="chart-title"><span>{title}</span> <span>{Math.round(scorePercent*100)}%</span></div>
				<div className="chart-bar-container">
					<div className="chart-bar" style={{ width: scorePercent * 100 + "%" }}>
						<div className="chart-tooltip"><div>{scorePercent * 100 + " %"}</div>
							<div className="arrow-down"></div>
							<div className="arrow-down-outline"></div>
						</div>
					</div>
				</div>
				<div className="chart-expand" onClick={onToggle}>
					<FontAwesomeIcon icon={["fal", isOpen ? "minus" : "plus"]} />
				</div>
			</div>
			{isOpen && children}
		</div>
	);
}
